module.exports = __webpack_public_path__ + "static/media/category5.6ccee04c.png";